import { Skeleton, TableCell, TableRow } from "@mui/material";

const DEFAULT_ROW_HEIGHT = 52;
export const TABLE_SKELETON_MAX_ROWS = 8;

type TableSkeletonRowsProps = {
    rowCount: number;
    columnCount: number;
    rowHeight?: number;
    withCheckboxColumn?: boolean;
    checkboxColumnMinWidth?: number | string;
};

const TableSkeletonRows = ({
    rowCount,
    columnCount,
    rowHeight = DEFAULT_ROW_HEIGHT,
    withCheckboxColumn = false,
    checkboxColumnMinWidth = "48px",
}: TableSkeletonRowsProps) =>
    Array.from({ length: rowCount }, (_, rowIndex) => (
        <TableRow key={`table-skeleton-${rowIndex}`} sx={{ height: rowHeight }}>
            {Array.from({ length: columnCount }, (_, columnIndex) => {
                const isCheckboxColumn = withCheckboxColumn && columnIndex === 0;

                return (
                    <TableCell
                        key={`table-skeleton-${rowIndex}-${columnIndex}`}
                        sx={{
                            height: rowHeight,
                            ...(isCheckboxColumn
                                ? {
                                      padding: "10px",
                                      textAlign: "center",
                                      width: checkboxColumnMinWidth,
                                      minWidth: checkboxColumnMinWidth,
                                  }
                                : {}),
                        }}
                    >
                        {isCheckboxColumn ? (
                            <Skeleton variant="rounded" animation="wave" width={16} height={16} sx={{ mx: "auto" }} />
                        ) : (
                            <Skeleton variant="text" />
                        )}
                    </TableCell>
                );
            })}
        </TableRow>
    ));

export default TableSkeletonRows;
